<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="表情包名称：">
            <el-input v-model="query.emoName" placeholder="请输入名称" clearable size="small" />
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="query.emoStatus" placeholder="全部" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <!-- <el-button type="primary" size="mini" @click="handleExport" plain>导出</el-button> -->
          <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button>
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">新增表情包</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column type="selection" width="55" />
        <el-table-column label="表情包名称" prop="emoName" align="center" />
        <el-table-column label="图片" prop="imgUrl" align="center">
          <template slot-scope="{row}">
            <el-image :src="row.imgUrl" style="width: 50px; height: 50px;" :preview-src-list="[row.imgUrl]" />
          </template>
        </el-table-column>
        <el-table-column label="排序" prop="sort" align="center" />
        <el-table-column label="状态" prop="emoStatus" align="center">
          <template slot-scope="{row}">
            <el-switch v-model="row.emoStatus" :active-value="1" :inactive-value="0" @change="changeSwitch(row)" />{{ row.emoStatus ? '启用' : '禁用' }}
          </template>
        </el-table-column>
        <el-table-column label="操作时间" prop="operatedTime" align="center" />
        <el-table-column label="操作人" prop="operatedByName" align="center" />
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)">编辑</el-button>
            <el-button type="text" @click="handleDeleteSingle(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <live-add ref="liveAdd" @created="doQueryList({})" />
  </div>
</template>

<script>
import liveAdd from './add'
import liveManageApi from '@/api/live/liveManage'
import Pagination from '@/components/Pagination'
export default {
  components: {
    Pagination,
    liveAdd,
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      selectItems: []
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleExport() {
      this.$message && this.$message.info('导出功能开发中')
    },
    handleRecharge(row) {
      this.$refs.recharge.handleShow(row)
    },
    handleLiveGoods(row) {
      this.$refs.liveGoods.handleShow(row)
    },
    copyStreamUrl(url) {
      this.$copyText(url).then(() => {
        this.$message.success('复制成功')
      })
    },
    handleFilter() {
      this.query = {}
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      return liveManageApi.fetchListEmo(this.query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => liveManageApi.deleteBatchEmo({ids: [row.id]}))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => liveManageApi.deleteBatchEmo({ids: this.selectItems.map(row => row.id)}))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    beforeHandleCommand(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择')
        return
      }
      let ids = this.selectItems.map(row => row.id)
      let txt = ""
      if (command.command === 1) {
        this.handleBatchState(ids, 1)
      } else if (command.command === 2) {
        this.handleBatchState(ids, 0)
      }
    },
    handleBatchState(ids, type) {
      let txt = type === 1 ? '确认将选中批量启用？' : '确认将选中批量禁用？'
      this.$common.confirm(txt).then(() => liveManageApi.setIsEnableBatch({ ids: ids, isEnable: type ? true : false }))
        .then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    changeSwitch(row) {
      let params = JSON.parse(JSON.stringify(row))
      liveManageApi.createEmo(params).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.liveAdd.handleCreate(row)
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      this.$emit('handleShow', row, 2)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.liveAdd.handleUpdate(row)
    }
  }
}
</script>
